// @flow

export function filterArgentineCashBankCode(incomingPaymentType:?string): string {
  const argentineCashBankCodes = ['rapipago', 'pagofacil'];
  if(incomingPaymentType && argentineCashBankCodes.includes(incomingPaymentType)) {
    return incomingPaymentType;
  }

  return '';
}
